module.exports = __webpack_public_path__ + "public/img/21.29259be3.png";